module.exports = __webpack_public_path__ + "img/debit-card.e1020d0a.png";